import { Component, inject } from '@angular/core'
import { FormsModule } from '@angular/forms'

import { TooltipModule } from 'primeng/tooltip'

import {
  FlxButtonComponent,
  FlxSegmentedButtonComponent,
  FlxSegmentedOptionComponent,
} from '@flowx/angular-ui-toolkit'
import {
  AiBuilderStore,
  AiBuilderView,
} from '@flowx/designer/modules/ai-builder/store/ai-builder.store'

/** One control for the AI assist on the header: the sparkles toggle and, while pressed, the
 * builder's views as the toolkit's segments. Amber is spent on the sparkles alone; the dark
 * segments sit on the banner, so a mode that is always on reads as part of the bar rather than a
 * warning in it. The views name the pane BESIDE the conversation, which is in both. */
@Component({
  selector: 'flx-ai-builder-toggle',
  imports: [
    FormsModule,
    TooltipModule,
    FlxButtonComponent,
    FlxSegmentedButtonComponent,
    FlxSegmentedOptionComponent,
  ],
  templateUrl: './ai-builder-toggle.component.html',
  styleUrl: './ai-builder-toggle.component.scss',
})
export class AiBuilderToggleComponent {
  readonly builder = inject(AiBuilderStore)

  readonly views: readonly { value: AiBuilderView; label: string; title: string }[] = [
    { value: 'make', label: 'Make', title: 'The designer, with the agent beside it' },
    { value: 'plan', label: 'Plan', title: 'The one-pager and the plan' },
  ]
}
